<template>
  <b-modal
    id="modal-editPackage"
    title="Uredi paket"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="dark"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="10">
        <b-form class="editPackage">
          <b-form-row>
            <b-col cols="12">
              <b-form-group description="Naziv paketa">
                <b-input
                  required
                  size="md"
                  v-model="form.title"
                  type="text"
                  :placeholder="currentPackage.title"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="3">
              <b-form-checkbox
                id="checkbox-active"
                v-model="form.is_active"
                name="active"
                unchecked-value="0"
                class="mb-2"
                switch
              >
                Paket je aktiven.
              </b-form-checkbox>
            </b-col>
            <b-col cols="3">
              <b-form-checkbox
                id="checkbox-1"
                v-model="form.rewards"
                name="rewards"
                unchecked-value="0"
                class="mb-2"
                switch
              >
                Paket je za charity.
              </b-form-checkbox>
            </b-col>
            <b-col cols="6">
              <b-form-group
                description="Povezava do splošnih pogojev nagradne igre."
              >
                <b-input
                  required
                  size="md"
                  v-model="form.reward_terms"
                  type="text"
                  :placeholder="currentPackage.reward_terms"
                  :disabled="form.rewards ? false : true"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Intro tekst</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže na začetku paketa.</small
              >
              <TipTap
                v-bind:richdata="form.intro_text"
                @htmlChange="introChanged"
              />
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Tekst Forma</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže ob prikaže ob formi paketa.</small
              >
              <TipTap
                v-bind:richdata="form.form_text"
                @htmlChange="formTextChanged"
              />
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Tekst Finiš</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže, ko uporabnik zaključi vse ankete v
                paketu.</small
              >
              <TipTap
                v-bind:richdata="form.finish_text"
                @htmlChange="finishTextChanged"
              />
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-editPackage')"
        class="btn btn-muted btn-md"
      >
        Cancel
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Shrani projekt
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import TipTap from "@/components/tools/TipTap.vue";

export default {
  components: { TipTap },
  data() {
    return {
      isSending: false,
      form: {
        title: "",
        rewards: "",
        rewards_terms: "",
        finish_text: "",
        form_text: "",
        intro_text: "",
      },
    };
  },
  mounted: function() {},
  created() {
    let packageId = this.$route.params.packageId;
    this.$store.dispatch("api/fetchPackage", packageId).then(() => {
      this.form.rewards = this.currentPackage.rewards;
      this.form.reward_terms = this.currentPackage.reward_terms;
      this.form.title = this.currentPackage.title;
      this.form.finish_text = this.currentPackage.finish_text;
      this.form.form_text = this.currentPackage.form_text;
      this.form.intro_text = this.currentPackage.intro_text;
      this.form.is_active = this.currentPackage.is_active;
    });
  },
  computed: {
    ...mapGetters({
      currentPackage: "api/getPackage",
    }),
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      let submitData = this.form;

      return new Promise((resolve, reject) => {
        axios({
          url: `${this.$store.state.login.url}/api/dashboard/packages/${this.currentPackage.id}/update`,
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(submitData),
          method: "POST",
        })
          .then((response) => {
            // cleanup form
            this.isSending = false;
            this.$bvModal.hide("modal-newPackage");
            this.$router.go();
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
    introChanged(value) {
      this.form.intro_text = value;
    },
    formTextChanged(value) {
      this.form.form_text = value;
    },
    finishTextChanged(value) {
      this.form.finish_text = value;
    },
  },
};
</script>
